import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';

export function formatPhone(phone: string, cityCodeNotNecessary?: boolean): string {
  let mask = cityCodeNotNecessary ? '$1 ($2) $3-$4-$5' : '$1 $2 $3-$4-$5';
  if (/^7\d{10}$/.test(phone)) {
    mask = `+${mask}`;
  }

  return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, mask);
}

export const formatUrl = (url: string) => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return `http://${url}`;
};

export const formatFlatPrice = (minPrice?: number) =>
  minPrice ? `от ${numberToPrettyString(Math.floor(minPrice))} ₽` : 'нет в продаже';
